import React from 'react';
import SIcon from './SIcon';
import { faTag } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faTag} fa />;

export default Icon;
